module.exports = __webpack_public_path__ + "img/sass.e5739ba9.svg";